module.exports = __webpack_public_path__ + "img/bg_image.20130f2.jpg";